export const CREATE_VISITOR_REQUEST = 'CREATE_VISITOR_REQUEST';
export const CREATE_VISITOR_SUCCESS = 'CREATE_VISITOR_SUCCESS';
export const CREATE_VISITOR_FAILURE = 'CREATE_VISITOR_FAILURE';

export const FETCH_VISITORS_REQUEST = 'FETCH_VISITORS_REQUEST';
export const FETCH_VISITORS_SUCCESS = 'FETCH_VISITORS_SUCCESS';
export const FETCH_VISITORS_FAILURE = 'FETCH_VISITORS_FAILURE';

export const FETCH_VISITOR_REQUEST = 'FETCH_VISITOR_REQUEST';
export const FETCH_VISITOR_SUCCESS = 'FETCH_VISITOR_SUCCESS';
export const FETCH_VISITOR_FAILURE = 'FETCH_VISITOR_FAILURE';

export const DELETE_VISITOR_REQUEST = 'DELETE_VISITOR_REQUEST';
export const DELETE_VISITOR_SUCCESS = 'DELETE_VISITOR_SUCCESS';
export const DELETE_VISITOR_FAILURE = 'DELETE_VISITOR_FAILURE';

export const SET_VISITOR_COUNTRY = 'SET_VISITOR_COUNTRY';
